import React from 'react';

/**
 * Location Helper Component
 * Provides guidance for location issues and browser settings
 */
const LocationHelper = ({ onManualEntry }) => {
  return (
    <div className="card border-warning">
      <div className="card-body">
        <h6 className="card-title text-warning">
          <i className="bi bi-exclamation-triangle me-2"></i>
          Location Access Issue
        </h6>
        
        <div className="mb-3">
          <p className="card-text small mb-2">
            We need location access to provide better delivery experience. Here's how to enable it:
          </p>
          
          <div className="accordion accordion-flush" id="locationHelp">
            <div className="accordion-item">
              <h2 className="accordion-header" id="chromeHelp">
                <button 
                  className="accordion-button collapsed small" 
                  type="button" 
                  data-bs-toggle="collapse" 
                  data-bs-target="#chromeFix"
                >
                  🌐 Chrome/Edge/Safari
                </button>
              </h2>
              <div id="chromeFix" className="accordion-collapse collapse" data-bs-parent="#locationHelp">
                <div className="accordion-body small">
                  <ol className="mb-0">
                    <li>Look for the 🔒 or 📍 icon in your address bar</li>
                    <li>Click it and select "Allow" for Location</li>
                    <li>Refresh the page and try again</li>
                    <li>Or go to Site Settings → Location → Allow</li>
                  </ol>
                </div>
              </div>
            </div>
            
            <div className="accordion-item">
              <h2 className="accordion-header" id="firefoxHelp">
                <button 
                  className="accordion-button collapsed small" 
                  type="button" 
                  data-bs-toggle="collapse" 
                  data-bs-target="#firefoxFix"
                >
                  🦊 Firefox
                </button>
              </h2>
              <div id="firefoxFix" className="accordion-collapse collapse" data-bs-parent="#locationHelp">
                <div className="accordion-body small">
                  <ol className="mb-0">
                    <li>Click the shield icon in the address bar</li>
                    <li>Click "Enable" for Location Services</li>
                    <li>Or go to Settings → Privacy & Security → Permissions → Location</li>
                    <li>Find this site and set to "Allow"</li>
                  </ol>
                </div>
              </div>
            </div>
            
            <div className="accordion-item">
              <h2 className="accordion-header" id="mobileHelp">
                <button 
                  className="accordion-button collapsed small" 
                  type="button" 
                  data-bs-toggle="collapse" 
                  data-bs-target="#mobileFix"
                >
                  📱 Mobile Browsers
                </button>
              </h2>
              <div id="mobileFix" className="accordion-collapse collapse" data-bs-parent="#locationHelp">
                <div className="accordion-body small">
                  <ol className="mb-0">
                    <li>Check your device's location services are ON</li>
                    <li>In browser, tap the site info icon (usually left of URL)</li>
                    <li>Enable Location permissions</li>
                    <li>Refresh and try again</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="d-flex gap-2">
          <button 
            className="btn btn-primary btn-sm flex-fill"
            onClick={() => window.location.reload()}
            style={{backgroundColor: '#2A632D', borderColor: '#2A632D'}}
          >
            🔄 Try Again
          </button>
          <button 
            className="btn btn-outline-secondary btn-sm flex-fill"
            onClick={onManualEntry}
          >
            ✏️ Enter Manually
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationHelper;
